"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ComponentException = _interopRequireDefault(require("../exception/ComponentException"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Component Event Handler.
 */
var EventHandler = /*#__PURE__*/function () {
  /**
   * Class constructor.
   *
   * @param {object} options Options object.
   * @param {string[]} options.supportedEvents Supported events.
   * @param {string} options.componentName Component name.
   * @param {object} [options.scope] Scope to call callback in.
   */
  function EventHandler(options) {
    _classCallCheck(this, EventHandler);

    this.supportedEvents = options.supportedEvents;
    this._events = {};
    this._componentName = options.componentName;
    this._scope = options.scope || this;
  }
  /**
   * Adds an event listener.
   *
   * @param {string} name Event name.
   * @param {Function} listener The listener.
   */


  _createClass(EventHandler, [{
    key: "on",
    value: function on(name, listener) {
      if (!this.supportedEvents.includes(name)) {
        throw new _ComponentException.default('Event with name "' + name + '" is not supported.', this._componentName);
      }

      this._events[name] = this._events[name] || [];

      this._events[name].push(listener);
    }
    /**
     * Removes an event listener.
     *
     * @param {string} name Event name.
     * @param {Function} [listener] The listener. Will remove all listeners if not defined.
     */

  }, {
    key: "off",
    value: function off(name) {
      var listener = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!this.supportedEvents.includes(name)) {
        throw new _ComponentException.default('Event with name "' + name + '" is not supported.', this._componentName);
      }

      this._events[name] = this._events[name] || [];

      if (listener === null) {
        delete this._events[name];
      } else {
        var index = this._events[name].indexOf(listener);

        if (index !== -1) {
          this._events[name].splice(index, 1);
        }
      }
    }
    /**
     * Triggers an event.
     *
     * @param {string} name Event name.
     * @param {...object} args Arguments to send.
     */

  }, {
    key: "trigger",
    value: function trigger(name) {
      if (!this.supportedEvents.includes(name)) {
        throw new _ComponentException.default('Event with name "' + name + '" is not supported.', this._componentName);
      }

      this._events[name] = this._events[name] || [];
      this._events[name].isTriggered = true;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var _iterator = _createForOfIteratorHelper(this._events[name]),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var listener = _step.value;
          listener.apply(this._scope, args);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * Checks if an event has been triggered before.
     *
     * @param {string} name Event name.
     * @returns {boolean} TRUE if triggered before.
     */

  }, {
    key: "isTriggered",
    value: function isTriggered(name) {
      return Array.isArray(this._events[name]) && this._events[name].isTriggered === true;
    }
    /**
     * Returns changed events based on an object with new events.
     *
     * @param {object} newEvents Events to set as key/value. Example: { click: () => {} }.
     * @returns {object} Changed events.
     */

  }, {
    key: "getChangedEvents",
    value: function getChangedEvents(newEvents) {
      var changedEvents = {};

      if (newEvents) {
        for (var _i = 0, _Object$keys = Object.keys(newEvents); _i < _Object$keys.length; _i++) {
          var key = _Object$keys[_i];

          if (!this._events[name] || !this._events[name].includes(newEvents[key])) {
            changedEvents[name] = newEvents[name];
          }
        }
      }

      return changedEvents;
    }
  }]);

  return EventHandler;
}();

exports.default = EventHandler;